const { InnerBlocks } = wp.blockEditor;

export default ({ attributes }) => {
  const { margin } = attributes;

  return (
    <section className={`Self-service ${margin}`}>
      <div className="SelfService__content">
        <InnerBlocks.Content />
      </div>
    </section>
  );
};
